<template>
  <div class="image-annotator-container">
    <div class="toolbar">
      <!-- 内联工具栏 -->
      <div
        class="toolbar-container"
        style="
          display: flex;
          gap: 1px;
          padding: 4px;
          background: #f5f5f5;
          border-radius: 4px;
          align-items: center;
          justify-content: center;
          width: 100%;
        "
      >
        <div style="display: flex; gap: 1px; align-items: center">
          <button
            v-for="tool in toolbarTools"
            :key="tool.name"
            @click="handleToolChange(tool.name)"
            :class="['tool-button', { active: currentTool === tool.name }]"
            :title="tool.label"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s;
            "
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px"
              :style="{
                fill: currentTool === tool.name ? '#1890ff' : currentColor,
                stroke: currentTool === tool.name ? '#1890ff' : currentColor,
              }"
              v-html="tool.icon"
            ></svg>
          </button>
        </div>

        <div style="display: flex; gap: 1px; align-items: center">
          <button
            @click="handleDownloadWord"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="下载Word文档"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M13,3.5V9H18.5L13,3.5M7,13L8.5,20H10.5L12,17L13.5,20H15.5L17,13H18V11H14V13H15L14.1,17.2L13,15V15H11V15L9.9,17.2L9,13H10V11H6V13H7Z"
              />
            </svg>
          </button>
          <button
            @click="handleUndo"
            :class="['action-button', { disabled: !canUndo }]"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="撤销"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z"
              />
            </svg>
          </button>
          <button
            @click="handleReset"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="重置"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
              />
            </svg>
          </button>
          <button
            @click="handleSave(false)"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="保存"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"
              />
            </svg>
          </button>
          <button
            @click="handleSave(true)"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="保存并审批"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3M19 19H5V5H16.17L19 7.83V19M12 12C10.34 12 9 13.34 9 15S10.34 18 12 18 15 16.66 15 15 13.66 12 12 12M6 6H15V10H6V6Z M12.75 17L15 14.75L14.25 14L12.75 15.5L11.75 14.5L11 15.25L12.75 17"
              />
            </svg>
          </button>
          <button
            @click="handleForward"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="保存并转发"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
              />
            </svg>
          </button>
          <button
            @click="closeComponent"
            class="action-button"
            style="
              width: 36px;
              height: 36px;
              padding: 8px;
              border: 1px solid #ddd;
              background: white;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
            "
            title="关闭"
          >
            <svg
              class="icon"
              viewBox="0 0 24 24"
              style="width: 20px; height: 20px; fill: currentColor"
            >
              <path
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="canvas-container">
      <!-- Konva 容器 -->
      <div ref="stageContainer" class="stage-container"></div>

      <!-- 浮动属性设置面板 -->
      <div
        v-if="showPropertyPanel"
        class="floating-property-panel"
        :class="{
          'above-shape': selectedShapePosition.positionType === 'above',
          'below-shape': selectedShapePosition.positionType === 'below',
        }"
        :style="propertyPanelStyle"
      >
        <div class="property-panel-content">
          <!-- 颜色选择器 -->
          <div class="property-item">
            <span class="property-label">颜色:</span>
            <div class="color-options">
              <div
                v-for="color in strokeColors"
                :key="color"
                class="color-option"
                :style="{ background: color }"
                :class="{ active: selectedShapeStrokeColor === color }"
                @click="updateStrokeColor(color)"
              ></div>
            </div>
          </div>

          <!-- 线条粗细选择器 -->
          <div class="property-item">
            <span class="property-label">粗细:</span>
            <div class="width-options">
              <div
                v-for="width in strokeWidths"
                :key="width"
                class="width-option"
                :class="{ active: selectedShapeStrokeWidth === width }"
                @click="updateStrokeWidth(width)"
              >
                <div
                  class="width-preview"
                  :style="{ height: `${width}px`, background: selectedShapeStrokeColor }"
                ></div>
              </div>
            </div>
          </div>

          <!-- 删除按钮 -->
          <div class="property-item">
            <button class="delete-button" @click="deleteSelectedShape"><span>🗑️</span> 删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加转发弹窗 -->
    <forward-dialog
      :visible.sync="showForwardDialog"
      @saveAndSend="handleSaveAndSend"
      @success="handleForwardSuccess"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { TOOLS, DEFAULT_COLORS, STROKE_WIDTHS, STROKE_COLORS } from './constants'
import ForwardDialog from './ForwardDialog.vue'

export default {
  name: 'ImageAnnotatorNew',
  components: {
    ForwardDialog,
  },
  props: {
    captureProps: {
      type: Object,
      default: () => {
        return {
          imgUrl: '',
        }
      },
    },
  },
  data() {
    return {
      // Konva 相关引用
      stage: null,
      backgroundLayer: null,
      mainLayer: null,
      transformer: null,

      // 状态变量
      currentTool: TOOLS.SELECT,
      isDrawing: false,
      startPoint: { x: 0, y: 0 },
      selectedShape: null,
      showPropertyPanel: false,
      selectedShapePosition: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        positionType: 'above',
      },
      selectedShapeStrokeColor: DEFAULT_COLORS.STROKE,
      selectedShapeStrokeWidth: 2,
      strokeWidths: STROKE_WIDTHS,
      strokeColors: STROKE_COLORS,
      debugInfo: '',
      currentPath: null,

      // 形状类型和索引
      selectedShapeType: null,
      selectedShapeIndex: -1,
      selectedShapeFillColor: 'transparent',
      showFillColorOption: false,

      // 形状数组
      rectangles: [],
      circles: [],
      lines: [],
      texts: [],
      paths: [],
      arrows: [],
      clouds: [],
      ellipses: [],
      backgroundImage: null,

      // 历史记录管理
      history: [],
      currentHistoryIndex: -1,
      maxHistorySteps: 50,

      // 文本编辑变量
      showTextEditor: false,
      textEditor: null,
      textEditorStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100px',
        height: '20px',
        display: 'none',
      },
      editingText: null,
      activeTextNode: null,
      isTextEditing: false,
      originalText: '',

      // 其他
      currentColor: '#000000',
      showForwardDialog: false,
    }
  },
  computed: {
    // 属性面板样式
    propertyPanelStyle() {
      return {
        position: 'absolute',
        left: `${this.selectedShapePosition.x}px`,
        top: `${this.selectedShapePosition.y}px`,
        transform: 'translateX(-50%)',
        zIndex: 1000,
      }
    },

    // 是否可以撤销
    canUndo() {
      return this.currentHistoryIndex > 0
    },

    // 是否可以重做
    canRedo() {
      return this.currentHistoryIndex < this.history.length - 1
    },

    // 工具栏工具数据
    toolbarTools() {
      return [
        {
          name: 'cloud',
          label: '云形',
          icon:
            '<path d="M5,15C3.34,15 2,13.66 2,12C2,10.34 3.34,9 5,9C5.37,9 5.72,9.06 6.05,9.17C6.03,8.95 6,8.73 6,8.5C6,6.01 8.01,4 10.5,4C12.69,4 14.46,5.52 14.9,7.53C15.25,7.19 15.75,7 16.25,7C17.49,7 18.5,8.01 18.5,9.25C18.5,9.27 18.5,9.28 18.5,9.3C20.39,9.7 21.74,11.38 21.74,13.32C21.74,15.5 19.96,17.32 17.74,17.32H5Z" stroke-width="1.5" fill="none" />',
          useStroke: true,
        },
        {
          name: 'rectangle',
          label: '矩形',
          icon: '<path d="M4,4H20V20H4V4M6,6V18H18V6H6Z" />',
        },
        {
          name: 'circle',
          label: '圆形',
          icon:
            '<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />',
        },
        {
          name: 'arrow',
          label: '箭头',
          icon: '<path d="M4,20 L20,4 M20,4 L14,4 M20,4 L20,10"  stroke-width="1.5" fill="none" />',
          useStroke: true,
        },
        {
          name: 'text',
          label: '文本',
          icon:
            '<path d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" />',
        },
        {
          name: 'freehand',
          label: '自由绘制',
          icon:
            '<path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />',
        },
        {
          name: 'select',
          label: '选择',
          icon:
            '<path d="M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z" />',
        },
      ]
    },

    fileContainer() {
      return document.getElementById('filePreview')
    },

    // 舞台配置
    stageConfig() {
      const container = this.$refs.stageContainer
      if (!container) return { width: 800, height: 600 }

      const parentElement = container.closest('.canvas-container') || container.parentElement
      return {
        width: parentElement ? parentElement.offsetWidth : window.innerWidth,
        height: parentElement ? parentElement.offsetHeight : window.innerHeight - 60, // 减去工具栏高度
      }
    },
  },
  watch: {
    selectedShape: {
      handler(newShape) {
        if (newShape) {
          if (newShape.getClassName() === 'Text') {
            // 对于文本，使用 fill 作为颜色
            this.selectedShapeStrokeColor = newShape.fill() || DEFAULT_COLORS.STROKE

            // 对于文本，根据 fontStyle 和 fontSize 判断粗细
            if (newShape.fontStyle() === 'bold') {
              // 根据字体大小判断应该选择哪个粗细
              const fontSize = newShape.fontSize()
              if (fontSize <= 14) {
                this.selectedShapeStrokeWidth = 1
              } else if (fontSize <= 16) {
                this.selectedShapeStrokeWidth = 2
              } else if (fontSize <= 18) {
                this.selectedShapeStrokeWidth = 4
              } else if (fontSize <= 20) {
                this.selectedShapeStrokeWidth = 6
              } else {
                this.selectedShapeStrokeWidth = 8
              }
            } else {
              // 正常字体，根据字体大小判断
              const fontSize = newShape.fontSize()
              if (fontSize <= 14) {
                this.selectedShapeStrokeWidth = 1
              } else {
                this.selectedShapeStrokeWidth = 2
              }
            }
          } else {
            // 非文本形状
            // 强制更新线条颜色
            if (newShape.stroke) {
              this.selectedShapeStrokeColor = newShape.stroke()
            } else {
              this.selectedShapeStrokeColor = DEFAULT_COLORS.STROKE
            }

            // 强制更新线条粗细
            if (newShape.strokeWidth) {
              this.selectedShapeStrokeWidth = newShape.strokeWidth()
            } else {
              this.selectedShapeStrokeWidth = 2
            }
          }
        } else {
          // 如果取消选中，重置为默认值
          this.selectedShapeStrokeColor = DEFAULT_COLORS.STROKE
          this.selectedShapeStrokeWidth = 2
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log('Component mounted, initializing...')
      setTimeout(() => {
        this.initStage()

        // 添加键盘事件监听
        document.addEventListener('keydown', this.handleKeyDown)

        // 添加窗口大小变化事件监听
        window.addEventListener('resize', this.handleResize)

        // 等待 stage 初始化完成后再添加事件监听器
        this.$nextTick(() => {
          if (this.stage) {
            // 添加全局双击事件处理
            this.stage.on('dblclick', this.handleStageDblClick)

            // 添加全局事件监听，确保在任何形状变化后更新属性面板位置
            this.stage.on('dragend', this.handleGlobalDragEnd)

            // 添加 transformer 的事件监听
            if (this.transformer) {
              this.transformer.on('transform', (e) => {
                const shape = e.target
                if (shape.getClassName() === 'Text') {
                  const scaleX = shape.scaleX()
                  // 只调整宽度
                  const newWidth = Math.max(30, shape.width() * scaleX)
                  shape.width(newWidth)
                  shape.scaleX(1)
                  // 保证自动换行
                  shape.wrap('word')
                  // 自动调整高度以包裹内容
                  if (typeof shape.getSelfRect === 'function') {
                    shape.height(shape.getSelfRect().height)
                  } else if (typeof shape.getTextHeight === 'function') {
                    shape.height(shape.getTextHeight())
                  }
                  this.mainLayer.batchDraw()
                }
              })
              this.transformer.on('transformend', () => {
                if (this.selectedShape) {
                  setTimeout(() => {
                    this.updatePropertyPanelPosition()
                  }, 0)
                }
              })
            }
          }
        })

        // 发出 mounted 事件
        this.$emit('mounted')
      }, 200)

      // 初始化时添加事件
      this.$nextTick(() => {
        this.addTextEvents()
      })
    })
  },
  beforeDestroy() {
    console.log('Component unmounting, cleaning up...')

    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeyDown)

    // 移除窗口大小变化事件监听
    window.removeEventListener('resize', this.handleResize)

    // 销毁 Konva 舞台和图层
    if (this.stage) {
      this.stage.destroy()
    }

    // 清空引用
    this.stage = null
    this.backgroundLayer = null
    this.mainLayer = null
    this.transformer = null

    // 如果正在编辑文本，完成编辑
    if (this.showTextEditor) {
      this.completeTextEditing()
    }

    // 如果正在编辑文本，清理编辑器
    if (this.isTextEditing) {
      this.cleanupTextEditor()
    }
  },
  methods: {
    // 防抖函数，避免短时间内多次保存历史记录
    debounce(fn, delay) {
      let timer = null
      return function(...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    },

    // 使用防抖包装 saveToHistory 函数
    debouncedSaveToHistory() {
      try {
        // 如果当前不是最新状态，删除当前索引之后的所有历史
        if (this.currentHistoryIndex < this.history.length - 1) {
          this.history = this.history.slice(0, this.currentHistoryIndex + 1)
        }

        // 获取当前所有形状的状态
        const currentState = this.mainLayer.children.map((shape) => {
          return {
            className: shape.getClassName(),
            attrs: shape.getAttrs(),
            id: shape._id,
          }
        })

        // 避免保存相同的状态
        const lastState = this.history[this.history.length - 1]
        if (lastState && JSON.stringify(lastState) === JSON.stringify(currentState)) {
          return
        }

        // 添加到历史记录
        this.history.push(currentState)
        this.currentHistoryIndex = this.history.length - 1

        // 限制历史记录的长度
        if (this.history.length > this.maxHistorySteps) {
          this.history = this.history.slice(this.history.length - this.maxHistorySteps)
          this.currentHistoryIndex = this.history.length - 1
        }

        console.log('Saved to history', this.currentHistoryIndex)
      } catch (error) {
        console.error('Error saving to history:', error)
      }
    },

    // 保存当前状态到历史记录
    saveToHistory() {
      // 使用 _.debounce 包装函数，限制调用频率
      if (!this._debouncedSaveToHistory) {
        this._debouncedSaveToHistory = this.debounce(this.debouncedSaveToHistory, 500)
      }
      this._debouncedSaveToHistory()
    },

    // 初始化 Konva 舞台
    initStage() {
      try {
        console.log('Initializing stage')

        // 获取容器引用
        const container = this.$refs.stageContainer
        if (!container) {
          console.error('Stage container not found, will retry in 100ms')
          this.debugInfo = '找不到舞台容器元素，正在重试...'

          // 设置重试
          setTimeout(() => {
            console.log('Retrying stage initialization')
            this.initStage()
          }, 100)
          return
        }

        console.log('Container found:', container)

        // 获取父容器尺寸 - 确保使用完整容器尺寸
        const parentElement = container.closest('.canvas-container') || container.parentElement
        // 确保使用全部可用空间，不减去工具栏高度，因为已经在flex布局中考虑了工具栏
        const width = parentElement.offsetWidth || window.innerWidth
        const height = parentElement.offsetHeight || window.innerHeight

        console.log('Calculated dimensions:', width, 'x', height)

        // 创建舞台，确保舞台尺寸与容器匹配
        this.stage = new Konva.Stage({
          container,
          width,
          height,
        })

        console.log('Stage created with dimensions:', width, 'x', height)

        // 创建图层
        this.backgroundLayer = new Konva.Layer()
        this.mainLayer = new Konva.Layer()

        // 添加图层到舞台
        this.stage.add(this.backgroundLayer)
        this.stage.add(this.mainLayer)

        // 创建变换器
        this.transformer = new Konva.Transformer({
          rotateEnabled: true,
          enabledAnchors: [
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
            'middle-left',
            'middle-right',
          ],
          boundBoxFunc: (oldBox, newBox) => {
            // 设置最小尺寸
            const minWidth = 20
            const minHeight = 20

            // 确保不会小于最小尺寸
            if (newBox.width < minWidth) {
              newBox.width = minWidth
            }
            if (newBox.height < minHeight) {
              newBox.height = minHeight
            }

            return newBox
          },
          // 添加变换事件处理
          transform: (e) => {
            const shape = e.target
            if (shape.getClassName() === 'Text') {
              // 获取当前缩放比例
              const scaleX = shape.scaleX()
              const scaleY = shape.scaleY()

              // 使用较大的缩放比例来调整字体大小，确保文本随拉伸变化
              const scale = Math.max(scaleX, scaleY)
              const newFontSize = shape.fontSize() * scale

              // 更新文本属性
              shape.setAttrs({
                fontSize: newFontSize,
                width: shape.width() * scaleX,
                height: shape.height() * scaleY,
                scaleX: 1,
                scaleY: 1,
              })
            }
          },
        })

        // 添加变换器到主图层
        this.mainLayer.add(this.transformer)

        // 绑定事件
        this.stage.on('mousedown touchstart', this.handleMouseDown)
        this.stage.on('mousemove touchmove', this.handleMouseMove)
        this.stage.on('mouseup touchend', this.handleMouseUp)

        // 点击空白区域取消选择
        this.stage.on('click tap', (e) => {
          // 如果点击的不是形状（即点击了空白区域或背景）
          if (
            !e.target.hasName('rect') &&
            !e.target.hasName('circle') &&
            !e.target.hasName('line') &&
            !e.target.hasName('arrow') &&
            !e.target.hasName('text') &&
            !e.target.hasName('path') &&
            !e.target.hasName('cloud')
          ) {
            this.deselectShape()
            this.showPropertyPanel = false
            this.removePropertyPanel()
          }
        })

        // 加载初始图片
        if (this.captureProps && this.captureProps.imgUrl) {
          this.loadImage(this.captureProps.imgUrl)
        }

        // 在函数末尾添加保存初始状态
        this.$nextTick(() => {
          this.saveToHistory()
        })

        this.debugInfo = '舞台已初始化'
        console.log('Stage initialized successfully')

        // 添加窗口大小变化事件处理
        window.addEventListener('resize', this.handleResize)
      } catch (error) {
        console.error('Error initializing stage:', error)
        this.debugInfo = `舞台初始化错误: ${error.message}`
      }
    },

    // 处理窗口大小调整
    handleResize() {
      if (!this.stage || !this.$refs.stageContainer) return

      // 获取容器新尺寸
      const container = this.$refs.stageContainer
      const parentElement = container.closest('.canvas-container') || container.parentElement
      // 使用全部可用空间
      const width = parentElement.offsetWidth || window.innerWidth
      const height = parentElement.offsetHeight || window.innerHeight

      console.log('Window resized, new dimensions:', width, 'x', height)

      // 更新舞台尺寸
      this.stage.width(width)
      this.stage.height(height)

      // 如果有背景图像，调整背景图像大小
      if (this.backgroundImage) {
        this.positionImage(this.backgroundImage)
      }

      // 重绘所有图层
      this.backgroundLayer.draw()
      this.mainLayer.draw()
    },

    // 加载图片
    loadImage(url) {
      console.log('Loading image from URL:', url)
      return new Promise((resolve, reject) => {
        if (!url) {
          console.error('No image URL provided')
          this.createEmptyBackground()
          reject(new Error('No image URL provided'))
          return
        }

        const img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = () => {
          console.log('Image loaded successfully. Dimensions:', img.width, 'x', img.height)

          // 清除现有背景层内容
          if (this.backgroundLayer) {
            this.backgroundLayer.destroyChildren()
          }

          // 首先创建一个全尺寸的背景矩形，确保整个画布都被填充
          const stageWidth = this.stage.width()
          const stageHeight = this.stage.height()

          // 添加白色背景确保图像下方不透明
          const background = new Konva.Rect({
            x: 0,
            y: 0,
            width: stageWidth,
            height: stageHeight,
            fill: '#ffffff',
            name: 'backgroundRect',
          })
          this.backgroundLayer.add(background)

          console.log('Stage dimensions:', stageWidth, 'x', stageHeight)

          // 创建图像对象
          const konvaImage = new Konva.Image({
            image: img,
            name: 'backgroundImage',
          })

          // 将图像添加到背景图层
          this.backgroundLayer.add(konvaImage)
          this.backgroundImage = konvaImage

          // 调整图像大小和位置
          this.positionImage(konvaImage)

          // 绘制背景图层
          this.backgroundLayer.draw()

          console.log('Image positioned and drawn on stage')
          resolve(konvaImage)
        }

        img.onerror = (error) => {
          console.error('Failed to load image:', error)
          this.createEmptyBackground()
          reject(error)
        }

        img.src = url
      })
    },

    // 调整图像位置和大小
    positionImage(imageNode) {
      if (!imageNode || !this.stage) return

      const img = imageNode.image()
      const stageWidth = this.stage.width()
      const stageHeight = this.stage.height()

      // 计算图像宽高比
      const imageRatio = img.width / img.height
      const stageRatio = stageWidth / stageHeight

      let newWidth
      let newHeight
      let x
      let y

      // 调整图像大小，确保完全填充画布并覆盖全部区域
      if (stageRatio > imageRatio) {
        // 舞台宽高比大于图像，以宽度为基准并稍微放大以避免边缘
        newWidth = stageWidth * 1.01 // 略微放大1%以消除边缘
        newHeight = newWidth / imageRatio
      } else {
        // 舞台宽高比小于图像，以高度为基准并稍微放大以避免边缘
        newHeight = stageHeight * 1.01 // 略微放大1%以消除边缘
        newWidth = newHeight * imageRatio
      }

      // 居中显示
      x = (stageWidth - newWidth) / 2
      y = (stageHeight - newHeight) / 2

      // 更新图像属性
      imageNode.width(newWidth)
      imageNode.height(newHeight)
      imageNode.x(x)
      imageNode.y(y)
    },

    // 创建空白背景
    createEmptyBackground() {
      console.log('Creating empty background')

      // 使用舞台尺寸
      // 使用舞台尺寸而不是filePreview元素
      const stageWidth = this.stage ? this.stage.width() : 800
      const stageHeight = this.stage ? this.stage.height() : 600

      // 创建矩形作为背景
      const background = new Konva.Rect({
        x: 0,
        y: 0,
        width: stageWidth,
        height: stageHeight,
        fill: '#f0f0f0',
        name: 'emptyBackground',
      })

      // 添加到背景图层
      this.backgroundLayer.add(background)
      this.backgroundLayer.draw()

      console.log('Empty background created with dimensions:', stageWidth, 'x', stageHeight)
    },

    // 处理工具切换
    handleToolChange(tool) {
      console.log('Tool changed to:', tool)

      // 如果当前正在编辑文本，先完成编辑
      if (this.isTextEditing) {
        this.finishTextEdit()
      }

      // 如果切换到非选择工具，取消选中
      if (tool !== TOOLS.SELECT && this.selectedShape) {
        this.deselectShape()
      }

      // 更新当前工具
      this.currentTool = tool

      // 如果切换到选择工具，更新鼠标样式
      if (tool === TOOLS.SELECT) {
        this.stage.container().style.cursor = 'default'
      } else {
        this.stage.container().style.cursor = 'crosshair'
      }
    },

    // 鼠标事件处理
    handleMouseDown(e) {
      // 如果正在编辑文本，先完成编辑
      if (this.isTextEditing) {
        this.finishTextEdit()
        return
      }

      // 如果是选择工具，处理选择逻辑
      if (this.currentTool === TOOLS.SELECT) {
        // 如果点击的是舞台空白区域，取消选择
        if (e.target === this.stage) {
          this.deselectShape()
          this.showPropertyPanel = false
          this.removePropertyPanel()
          return
        }

        // 如果点击的不是形状，不处理选择
        if (
          !e.target.hasName('rect') &&
          !e.target.hasName('circle') &&
          !e.target.hasName('line') &&
          !e.target.hasName('arrow') &&
          !e.target.hasName('text') &&
          !e.target.hasName('path') &&
          !e.target.hasName('cloud')
        ) {
          return
        }
      }

      // 获取点击位置
      const pos = this.stage.getPointerPosition()
      this.startPoint.x = pos.x
      this.startPoint.y = pos.y
      this.isDrawing = true

      // 创建形状
      const shape = this.createShape(pos)
      console.log('shape', shape)
      if (shape) {
        this.currentPath = shape
      }
    },

    handleMouseMove(e) {
      // 如果不是绘制状态，不处理
      if (!this.isDrawing) return

      // 获取当前鼠标位置
      const pos = this.stage.getPointerPosition()
      if (!pos) return

      // 根据当前工具更新形状
      switch (this.currentTool) {
        case TOOLS.RECTANGLE: {
          // 更新矩形尺寸
          const rect = this.currentPath
          const width = pos.x - this.startPoint.x
          const height = pos.y - this.startPoint.y

          // 处理负值情况
          if (width < 0) {
            rect.x(pos.x)
            rect.width(Math.abs(width))
          } else {
            rect.width(width)
          }

          if (height < 0) {
            rect.y(pos.y)
            rect.height(Math.abs(height))
          } else {
            rect.height(height)
          }
          break
        }

        case TOOLS.CIRCLE: {
          // 更新圆形半径
          const circle = this.currentPath
          const dx = pos.x - this.startPoint.x
          const dy = pos.y - this.startPoint.y
          const radius = Math.sqrt(dx * dx + dy * dy)
          circle.radius(radius)
          break
        }

        case TOOLS.LINE:
        case TOOLS.ARROW: {
          // 更新线条/箭头端点
          const line = this.currentPath
          const points = [this.startPoint.x, this.startPoint.y, pos.x, pos.y]
          line.points(points)
          break
        }

        case TOOLS.FREEHAND: {
          // 更新自由绘制路径
          const path = this.currentPath

          // 检查 path 是否是 Konva.Path 对象
          if (path && path.className === 'Path') {
            // 获取当前路径数据
            let pathData = path.data()

            // 添加新的线段
            pathData += ` L ${pos.x} ${pos.y}`

            // 更新路径数据
            path.data(pathData)

            // 保存当前路径数据字符串，用于历史记录
            this.currentPath = path
          }
          break
        }

        case TOOLS.CLOUD: {
          // 更新云朵大小
          const cloud = this.currentPath
          const width = Math.abs(pos.x - this.startPoint.x)
          const height = Math.abs(pos.y - this.startPoint.y)
          const cloudPath = this.generateCloudPath(
            this.startPoint.x,
            this.startPoint.y,
            width,
            height
          )
          cloud.data(cloudPath)
          break
        }
      }

      // 重绘图层
      this.mainLayer.batchDraw()
    },

    handleMouseUp() {
      console.log('handleMouseUp', this.currentTool)
      // 如果不是绘制状态，不处理
      if (!this.isDrawing) return

      // 保存对刚创建的形状的引用
      const justCreatedShape = this.currentPath

      // 结束绘制
      this.isDrawing = false

      // 保存历史记录
      this.saveToHistory()

      // 重置当前路径（但不要重置自由绘制工具的路径对象）
      if (this.currentTool !== TOOLS.FREEHAND) {
        this.currentPath = null
      }

      // 切换到选择工具
      this.handleToolChange('select')

      // 在工具切换后，选中刚刚创建的形状
      if (justCreatedShape) {
        // 使用 nextTick 确保在工具切换完成后选中形状
        this.$nextTick(() => {
          console.log('Selecting newly created shape:', justCreatedShape.getClassName())
          this.selectShape(justCreatedShape)
        })
      }
    },

    // 键盘事件处理
    handleKeyDown(e) {
      // 如果正在编辑文本，不处理快捷键
      if (this.showTextEditor) return

      // Ctrl+Z: 撤销
      if (e.ctrlKey && e.key === 'z') {
        e.preventDefault()
        this.handleUndo()
      }

      // Delete: 删除选中的形状
      if (e.key === 'Delete' && this.selectedShape) {
        e.preventDefault()
        this.deleteSelectedShape()
      }

      // Escape: 取消选择
      if (e.key === 'Escape') {
        e.preventDefault()
        this.deselectShape()
      }
    },

    // 创建形状
    createShape(pos) {
      let shape = null

      // 根据当前工具创建相应的形状
      switch (this.currentTool) {
        case TOOLS.RECTANGLE: {
          // 创建新矩形
          shape = new Konva.Rect({
            x: pos.x,
            y: pos.y,
            width: 0,
            height: 0,
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            fill: 'transparent',
            draggable: true,
            name: 'rect',
          })

          // 只允许点击边框区域选中和拖动
          shape.on('mousedown touchstart', (e) => {
            const pointer = this.stage.getPointerPosition()
            const rect = shape
            const x = pointer.x - rect.x()
            const y = pointer.y - rect.y()
            const w = rect.width()
            const h = rect.height()
            const border = rect.strokeWidth() + 4 // 容差
            if (
              (x >= 0 && x <= w && (y < border || y > h - border)) ||
              (y >= 0 && y <= h && (x < border || x > w - border))
            ) {
              shape.draggable(true)
              this.handleShapeMouseDown(e, this.rectangles.length, 'rectangle')
            } else {
              shape.draggable(false)
              if (this.selectedShape) {
                this.deselectShape()
                e.cancelBubble = true
              }
            }
          })
          shape.on('mouseup touchend', () => {
            shape.draggable(true)
          })

          this.rectangles.push(shape)
          break
        }

        case TOOLS.CIRCLE: {
          // 创建新圆形
          shape = new Konva.Circle({
            x: pos.x,
            y: pos.y,
            radius: 0,
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            fill: 'transparent',
            draggable: true,
            name: 'circle',
          })

          // 只允许点击边框区域选中和拖动
          shape.on('mousedown touchstart', (e) => {
            const pointer = this.stage.getPointerPosition()
            const circle = shape
            const dx = pointer.x - circle.x()
            const dy = pointer.y - circle.y()
            const r = circle.radius()
            const border = circle.strokeWidth() + 4
            const dist = Math.sqrt(dx * dx + dy * dy)
            if (dist > r - border && dist < r + border) {
              shape.draggable(true)
              this.handleShapeMouseDown(e, this.circles.length, 'circle')
            } else {
              shape.draggable(false)
              if (this.selectedShape) {
                this.deselectShape()
                e.cancelBubble = true
              }
            }
          })
          shape.on('mouseup touchend', () => {
            shape.draggable(true)
          })

          this.circles.push(shape)
          break
        }

        case TOOLS.LINE: {
          // 创建新线条
          shape = new Konva.Line({
            points: [pos.x, pos.y, pos.x, pos.y],
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            lineCap: 'round',
            lineJoin: 'round',
            draggable: true,
            name: 'line',
          })

          // 只允许点击线附近选中
          shape.on('mousedown touchstart', (e) => {
            const pointer = this.stage.getPointerPosition()
            const points = shape.points()
            const x1 = points[0]
            const y1 = points[1]
            const x2 = points[2]
            const y2 = points[3]
            const px = pointer.x
            const py = pointer.y
            // 计算点到线段距离
            function pointToLineDist(x, y, x1, y1, x2, y2) {
              const A = x - x1
              const B = y - y1
              const C = x2 - x1
              const D = y2 - y1
              const dot = A * C + B * D
              const len_sq = C * C + D * D
              let param = -1
              if (len_sq !== 0) param = dot / len_sq
              let xx
              let yy
              if (param < 0) {
                xx = x1
                yy = y1
              } else if (param > 1) {
                xx = x2
                yy = y2
              } else {
                xx = x1 + param * C
                yy = y1 + param * D
              }
              const dx = x - xx
              const dy = y - yy
              return Math.sqrt(dx * dx + dy * dy)
            }
            const dist = pointToLineDist(px, py, x1, y1, x2, y2)
            const border = shape.strokeWidth() + 4
            if (dist < border) {
              this.handleShapeMouseDown(e, this.lines.length, 'line')
            } else if (this.selectedShape) {
              this.deselectShape()
              e.cancelBubble = true
            }
          })

          this.lines.push(shape)
          break
        }

        case TOOLS.ARROW: {
          // 创建新箭头
          shape = new Konva.Arrow({
            points: [pos.x, pos.y, pos.x, pos.y],
            pointerLength: 10,
            pointerWidth: 10,
            fill: this.selectedShapeStrokeColor,
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            draggable: true,
            name: 'arrow',
            pointerAtBeginning: false,
            pointerAtEnd: true,
            pointerFill: 'transparent',
          })

          // 只允许点击箭头线附近选中
          shape.on('mousedown touchstart', (e) => {
            const pointer = this.stage.getPointerPosition()
            const points = shape.points()
            const x1 = points[0]
            const y1 = points[1]
            const x2 = points[2]
            const y2 = points[3]
            const px = pointer.x
            const py = pointer.y
            function pointToLineDist(x, y, x1, y1, x2, y2) {
              const A = x - x1
              const B = y - y1
              const C = x2 - x1
              const D = y2 - y1
              const dot = A * C + B * D
              const len_sq = C * C + D * D
              let param = -1
              if (len_sq !== 0) param = dot / len_sq
              let xx
              let yy
              if (param < 0) {
                xx = x1
                yy = y1
              } else if (param > 1) {
                xx = x2
                yy = y2
              } else {
                xx = x1 + param * C
                yy = y1 + param * D
              }
              const dx = x - xx
              const dy = y - yy
              return Math.sqrt(dx * dx + dy * dy)
            }
            const dist = pointToLineDist(px, py, x1, y1, x2, y2)
            const border = shape.strokeWidth() + 6 // 箭头更宽容差
            if (dist < border) {
              this.handleShapeMouseDown(e, this.arrows.length, 'arrow')
            } else if (this.selectedShape) {
              this.deselectShape()
              e.cancelBubble = true
            }
          })

          this.arrows.push(shape)
          break
        }

        case TOOLS.TEXT: {
          // 直接调用 addText 函数（文本允许全部区域选中）
          shape = this.addText(pos)
          break
        }

        case TOOLS.CLOUD: {
          // 创建新云朵
          const cloudPath = this.generateCloudPath(pos.x, pos.y, 100, 60)
          shape = new Konva.Path({
            data: cloudPath,
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            fill: 'transparent',
            draggable: true,
            name: 'cloud',
          })

          // 先 push
          this.clouds.push(shape)

          // 绑定事件
          this.bindCloudShapeEvents(shape)

          break
        }

        case TOOLS.FREEHAND: {
          // 创建新自由绘制路径
          this.currentPath = `M ${pos.x} ${pos.y}`
          shape = new Konva.Path({
            data: this.currentPath,
            stroke: this.selectedShapeStrokeColor,
            strokeWidth: this.selectedShapeStrokeWidth,
            lineCap: 'round',
            lineJoin: 'round',
            draggable: true,
            name: 'path',
          })

          // 只允许点击边框区域选中
          shape.on('mousedown touchstart', (e) => {
            const pointer = this.stage.getPointerPosition()
            const path = shape
            const box = path.getClientRect()
            const border = path.strokeWidth() + 6
            if (
              pointer.x > box.x - border &&
              pointer.x < box.x + box.width + border &&
              pointer.y > box.y - border &&
              pointer.y < box.y + box.height + border
            ) {
              // 进一步判断是否在边缘
              const innerBox = {
                x: box.x + border,
                y: box.y + border,
                width: box.width - 2 * border,
                height: box.height - 2 * border,
              }
              if (
                pointer.x < innerBox.x ||
                pointer.x > innerBox.x + innerBox.width ||
                pointer.y < innerBox.y ||
                pointer.y > innerBox.y + innerBox.height
              ) {
                const idx = this.paths.indexOf(shape)
                this.handleShapeMouseDown(e, idx, 'freehand')
              } else if (this.selectedShape) {
                this.deselectShape()
                e.cancelBubble = true
              }
            } else if (this.selectedShape) {
              this.deselectShape()
              e.cancelBubble = true
            }
          })

          this.paths.push(shape)
          break
        }
      }

      // 如果创建了形状，添加通用事件处理
      if (shape) {
        // 添加拖动事件
        shape.on('dragmove', this.handleDragMove)
        shape.on('dragend', this.handleDragEnd)
        shape.on('transformend', this.handleTransformEnd)

        // 添加到图层
        if (this.currentTool !== TOOLS.TEXT) {
          // 文本已经在 case 中添加
          this.mainLayer.add(shape)
        }
      }

      return shape
    },

    // 生成云朵路径
    generateCloudPath(x, y, width, height) {
      const baseWidth = Math.max(width || 100, 40)
      const baseHeight = Math.max(height || 60, 30)

      // 计算云朵的各个"凸起"部分
      const path = []

      // 起始点
      path.push(`M ${x} ${y + baseHeight * 0.5}`)

      // 左侧凸起
      path.push(`C ${x - baseWidth * 0.1} ${y + baseHeight * 0.3}, 
                 ${x - baseWidth * 0.05} ${y}, 
                 ${x + baseWidth * 0.2} ${y + baseHeight * 0.2}`)

      // 顶部凸起
      path.push(`C ${x + baseWidth * 0.3} ${y - baseHeight * 0.1}, 
                 ${x + baseWidth * 0.5} ${y - baseHeight * 0.1}, 
                 ${x + baseWidth * 0.6} ${y + baseHeight * 0.1}`)

      // 右上凸起
      path.push(`C ${x + baseWidth * 0.7} ${y}, 
                 ${x + baseWidth * 0.9} ${y + baseHeight * 0.1}, 
                 ${x + baseWidth} ${y + baseHeight * 0.4}`)

      // 右侧凸起
      path.push(`C ${x + baseWidth * 1.1} ${y + baseHeight * 0.6}, 
                 ${x + baseWidth * 0.9} ${y + baseHeight * 0.8}, 
                 ${x + baseWidth * 0.7} ${y + baseHeight * 0.8}`)

      // 底部凸起
      path.push(`C ${x + baseWidth * 0.5} ${y + baseHeight * 1.05}, 
                 ${x + baseWidth * 0.3} ${y + baseHeight * 1.05}, 
                 ${x + baseWidth * 0.2} ${y + baseHeight * 0.9}`)

      // 左下凸起
      path.push(`C ${x + baseWidth * 0.1} ${y + baseHeight * 0.8}, 
                 ${x - baseWidth * 0.05} ${y + baseHeight * 0.7}, 
                 ${x} ${y + baseHeight * 0.5}`)

      // 闭合路径
      path.push('Z')

      return path.join(' ')
    },

    // ... 其他方法将在下个部分实现
    getUrlParam(url, name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`) // 构造一个含有目标参数的正则表达式对象
      const r = url.match(reg) // 匹配目标参数
      if (r != null) return unescape(r[2])
      return null // 返回参数值
    },

    // 文本编辑
    startTextEdit(textNode) {
      if (!textNode || this.isTextEditing) return

      try {
        // 确保之前的编辑器已被清理
        this.cleanupTextEditor()

        // 保存当前文本节点和原始文本
        this.activeTextNode = textNode
        this.originalText = textNode.text()
        this.isTextEditing = true

        // 隐藏文本节点
        textNode.visible(false)
        this.mainLayer.batchDraw()

        // 获取舞台和文本节点位置
        const stage = this.mainLayer.getStage()
        const stageBox = stage.container().getBoundingClientRect()
        const textPos = textNode.absolutePosition()

        // 创建文本编辑器
        const editor = document.createElement('textarea')
        editor.className = 'text-editor'
        editor.value = textNode.text()
        editor.style.position = 'fixed'
        editor.style.left = `${stageBox.left + textPos.x}px`
        editor.style.top = `${stageBox.top + textPos.y}px`
        editor.style.width = `${Math.max(100, textNode.width())}px`
        editor.style.height = `${Math.max(30, textNode.height())}px`
        editor.style.fontSize = `${textNode.fontSize()}px`
        editor.style.fontFamily = textNode.fontFamily()
        editor.style.color = textNode.fill()
        editor.style.border = '1px solid #1890ff'
        editor.style.padding = '4px'
        editor.style.margin = '0px'
        editor.style.overflow = 'hidden'
        editor.style.background = '#fff'
        editor.style.zIndex = '10000'
        editor.style.resize = 'none'
        editor.style.lineHeight = '1.2'
        editor.wrap = 'soft'
        editor.setAttribute('wrap', 'soft')
        editor.setAttribute('rows', '1')
        editor.setAttribute('spellcheck', 'false')

        // 自动调整高度和宽度
        const adjustEditorSize = () => {
          editor.style.height = 'auto'
          editor.style.height = `${editor.scrollHeight}px`
          // 可选：自动调整宽度（如需）
          // editor.style.width = Math.max(100, editor.scrollWidth) + 'px'
        }
        editor.addEventListener('input', adjustEditorSize)
        this.$nextTick(adjustEditorSize)

        // 使用一次性事件监听器，避免重复绑定
        editor.addEventListener('blur', this.finishTextEdit, { once: true })
        editor.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            this.finishTextEdit()
          }
          if (e.key === 'Escape') {
            e.preventDefault()
            this.cancelTextEdit()
          }
        })

        // 添加到页面并聚焦
        document.body.appendChild(editor)
        this.textEditor = editor
        editor.focus()
        editor.select()
      } catch (error) {
        console.error('Error starting text edit:', error)
        // 出错时确保清理
        this.cleanupTextEditor()
      }
    },

    // 完成文本编辑
    finishTextEdit() {
      if (!this.isTextEditing || !this.activeTextNode || !this.textEditor) return

      try {
        const newText = this.textEditor.value.trim()
        const textNode = this.activeTextNode

        // 更新文本内容
        if (newText !== this.originalText) {
          textNode.text(newText || '双击编辑文本')
          this.saveToHistory()
        }

        // 自动适应宽高和换行
        textNode.width(Math.max(100, this.textEditor.scrollWidth))
        textNode.height(this.textEditor.scrollHeight)
        textNode.wrap('word')

        // 显示文本节点
        textNode.visible(true)
        this.mainLayer.batchDraw()
      } catch (error) {
        console.warn('Error during text edit completion:', error)
      } finally {
        // 清理编辑器
        this.cleanupTextEditor()
      }
    },

    // 取消文本编辑
    cancelTextEdit() {
      if (!this.isTextEditing || !this.activeTextNode) return

      // 清理编辑器
      this.cleanupTextEditor()

      // 显示文本节点
      this.activeTextNode.visible(true)
      this.mainLayer.batchDraw()
    },

    // 清理文本编辑器
    cleanupTextEditor() {
      if (this.textEditor) {
        try {
          // 移除所有事件监听器
          const editor = this.textEditor
          editor.removeEventListener('blur', this.finishTextEdit)
          editor.removeEventListener('keydown', this.handleKeyDown)

          // 从 DOM 中移除 - 添加检查以确保元素仍然在文档中
          if (editor.parentNode && document.contains(editor)) {
            editor.parentNode.removeChild(editor)
          }
        } catch (error) {
          console.warn('Error during text editor cleanup:', error)
        } finally {
          // 无论如何都重置所有相关状态
          this.textEditor = null
          this.activeTextNode = null
          this.isTextEditing = false
          this.originalText = ''
        }
      }
    },

    // 创建新文本
    addText(pos) {
      // 创建新的文本节点
      const text = new Konva.Text({
        x: pos.x,
        y: pos.y,
        text: '双击编辑文本',
        fontSize: 16,
        fontFamily: 'Arial',
        fill: this.selectedShapeStrokeColor,
        draggable: true,
        name: 'text',
        width: 100, // 设置初始宽度
        height: 20, // 设置初始高度
        padding: 5, // 添加内边距
      })
      this.currentPath = text

      // 添加到图层和数组
      this.mainLayer.add(text)
      this.texts.push(text)

      // 添加事件监听
      text.on('mousedown touchstart', (e) => {
        if (this.currentTool === TOOLS.SELECT) {
          e.cancelBubble = true
          const idx = this.texts.indexOf(text)
          this.handleShapeMouseDown(e, idx, 'text')
          this.showPropertyPanel = true
          this.$nextTick(() => {
            this.updatePropertyPanelPosition()
          })
        }
      })

      text.on('dblclick', () => {
        if (this.currentTool === TOOLS.SELECT) {
          this.startTextEdit(text)
        }
      })

      text.on('transform', () => {
        // 获取当前缩放比例
        const scaleX = text.scaleX()
        const scaleY = text.scaleY()

        // 使用较大的缩放比例来调整字体大小
        const scale = Math.max(scaleX, scaleY)
        const newFontSize = text.fontSize() * scale

        // 更新文本属性
        text.setAttrs({
          fontSize: newFontSize,
          width: text.width() * scaleX,
          height: text.height() * scaleY,
          scaleX: 1,
          scaleY: 1,
        })
      })

      // 保存历史记录
      this.saveToHistory()

      // 开始编辑
      this.startTextEdit(text)

      return text
    },

    // 选择/取消选择形状
    selectShape(shape) {
      console.log('selectShape', shape)
      if (!shape) return

      console.log('Selecting shape:', shape.getClassName())

      // 取消当前选中
      this.deselectShape()

      // 设置新的选中形状
      this.selectedShape = shape

      // 根据形状类型设置选中类型和索引
      if (shape.getClassName() === 'Text') {
        this.selectedShapeType = 'text'
        this.selectedShapeIndex = this.texts.findIndex((t) => {
          return t === shape
        })
      } else if (shape.getClassName() === 'Rect') {
        this.selectedShapeType = 'rect'
        this.selectedShapeIndex = this.rectangles.findIndex((r) => {
          return r === shape
        })
      } else if (shape.getClassName() === 'Ellipse') {
        this.selectedShapeType = 'ellipse'
        this.selectedShapeIndex = this.ellipses.findIndex((e) => {
          return e === shape
        })
      } else if (shape.getClassName() === 'Line') {
        this.selectedShapeType = 'line'
        this.selectedShapeIndex = this.lines.findIndex((l) => {
          return l === shape
        })
      } else if (shape.getClassName() === 'Arrow') {
        this.selectedShapeType = 'arrow'
        this.selectedShapeIndex = this.arrows.findIndex((a) => {
          return a === shape
        })
      } else if (shape.getClassName() === 'Path') {
        if (shape.name() === 'cloud') {
          this.selectedShapeType = 'cloud'
          this.selectedShapeIndex = this.clouds.findIndex((c) => {
            return c === shape
          })
        } else {
          this.selectedShapeType = 'path'
          this.selectedShapeIndex = this.paths.findIndex((p) => {
            return p === shape
          })
        }
      }

      // 设置变换器
      this.transformer.nodes([shape])
      this.mainLayer.draw()

      // 显示属性面板
      this.showPropertyPanel = true

      // 更新属性面板位置
      this.$nextTick(() => {
        this.updatePropertyPanelPosition()
      })
    },

    // 更新属性面板位置方法
    updatePropertyPanelPosition() {
      if (!this.selectedShape || !this.stage) return

      console.log('Updating property panel position')

      // 获取选中形状的位置和尺寸
      const shape = this.selectedShape
      const shapeBox = shape.getClientRect()

      // 获取画布容器位置和尺寸
      const containerRect = this.$refs.stageContainer.getBoundingClientRect()
      const stageWidth = this.stage.width()
      const stageHeight = this.stage.height()

      // 判断面板位置（顶部还是底部）
      let positionType = 'above'
      const yOffset = 220 // 设置更大的默认偏移，确保不遮挡图形

      // 根据形状类型和位置确定面板位置
      const isNearTop = shapeBox.y - containerRect.top < 250
      const isNearBottom = containerRect.height - (shapeBox.y + shapeBox.height) < 200

      // 设置面板位置和类型
      let panelPosition = {}

      if (isNearTop && !isNearBottom) {
        // 靠近顶部但不靠近底部，放在形状下方
        positionType = 'below'
        panelPosition = {
          x: shapeBox.x + shapeBox.width / 2,
          y: shapeBox.y + shapeBox.height + 25,
          width: shapeBox.width,
          height: shapeBox.height,
          positionType: 'below',
        }
      } else {
        // 默认或靠近底部，放在形状上方
        panelPosition = {
          x: shapeBox.x + shapeBox.width / 2,
          y: Math.max(shapeBox.y - yOffset, 20),
          width: shapeBox.width,
          height: shapeBox.height,
          positionType: 'above',
        }
      }

      // 特殊形状处理
      if (shape.getClassName() === 'Arrow' || shape.getClassName() === 'Line') {
        // 对于箭头和线条，调整位置使面板更加明显
        const lineLength = Math.sqrt(
          Math.pow(shape.points()[2] - shape.points()[0], 2) +
            Math.pow(shape.points()[3] - shape.points()[1], 2)
        )

        // 如果线条很短，需要额外调整
        if (lineLength < 100) {
          if (positionType === 'above') {
            panelPosition.y = Math.max(shapeBox.y - 250, 20)
          } else {
            panelPosition.y = shapeBox.y + shapeBox.height + 50
          }
        }
      }

      // 确保面板始终在可视区域内
      // 检查左右边界
      if (panelPosition.x < 120) {
        panelPosition.x = 120 // 左边界距离
      } else if (panelPosition.x > stageWidth - 120) {
        panelPosition.x = stageWidth - 120 // 右边界距离
      }

      // 检查上下边界
      if (panelPosition.y < 20) {
        panelPosition.y = 20 // 上边界距离
      } else if (panelPosition.y > stageHeight - 120) {
        // 如果太靠近底部，强制放到上方
        panelPosition.y = Math.max(shapeBox.y - yOffset, 20)
        panelPosition.positionType = 'above'

        // 如果上方也放不下，调整到可见位置
        if (panelPosition.y < 20) {
          panelPosition.y = 20
        }
      }

      // 更新选中形状位置
      this.selectedShapePosition = panelPosition
    },

    // 修改 removePropertyPanel 方法
    removePropertyPanel() {
      // 只需隐藏Vue属性面板
      this.showPropertyPanel = false
    },

    // Handle shape mouse down event
    handleShapeMouseDown(e, index, type) {
      console.log('Shape mouse down:', type, index)

      // 如果不是选择工具，不处理选择逻辑
      if (this.currentTool !== TOOLS.SELECT) {
        return
      }

      // 阻止事件冒泡
      e.cancelBubble = true

      // 获取点击的形状
      const shape = e.target

      // 确保点击的是形状本身
      if (
        !shape ||
        (!shape.hasName('rect') &&
          !shape.hasName('circle') &&
          !shape.hasName('line') &&
          !shape.hasName('arrow') &&
          !shape.hasName('text') &&
          !shape.hasName('path') &&
          !shape.hasName('cloud'))
      ) {
        return
      }

      // 取消当前选择
      this.deselectShape()

      // 调用 selectShape 函数
      this.selectShape(shape)

      // 如果是文本形状，确保属性面板显示
      if (shape.getClassName() === 'Text') {
        this.showPropertyPanel = true
        this.$nextTick(() => {
          this.updatePropertyPanelPosition()
        })
      }
    },

    // Handle transform end event
    handleTransformEnd(e) {
      // Update shape properties
      if (this.selectedShape) {
        // 更新选中形状的属性
        if (this.selectedShape.stroke) {
          this.selectedShapeStrokeColor = this.selectedShape.stroke()
        }

        if (this.selectedShape.strokeWidth) {
          this.selectedShapeStrokeWidth = this.selectedShape.strokeWidth()
        }

        // 立即更新属性面板位置
        this.updatePropertyPanelPosition()

        // 保存历史记录
        this.saveToHistory()
      }
    },

    // 修改 handleDragEnd 函数，确保拖动结束后更新属性面板位置
    handleDragEnd(e) {
      // Similar to transform end
      if (this.selectedShape) {
        // 立即更新属性面板位置
        this.updatePropertyPanelPosition()

        // 保存历史记录
        this.saveToHistory()

        // 强制重绘以确保位置更新
        this.mainLayer.batchDraw()
      }
    },

    // 修改 handleTextDblClick 函数，确保先选中文本再编辑
    handleTextDblClick(e, index) {
      console.log('Text double clicked, index:', index)

      // 如果不是选择工具，不处理
      if (this.currentTool !== TOOLS.SELECT) {
        console.log('Not in select tool, ignoring double click')
        return
      }

      // 阻止事件冒泡
      e.cancelBubble = true

      // 获取文本节点
      const textNode = this.texts[index]
      if (!textNode) {
        console.error('Text node not found at index:', index)
        return
      }

      console.log('Found text node:', textNode.text())

      // 选中文本
      this.deselectShape()
      this.selectedShape = textNode
      this.selectedShapeType = 'text'
      this.selectedShapeIndex = index
      this.transformer.nodes([textNode])
      this.mainLayer.draw()

      // 开始编辑
      console.log('Starting text editing from double click')
      this.startTextEdit(textNode)
    },

    // 处理舞台双击事件
    handleStageDblClick(e) {
      console.log('Stage double clicked, target:', e.target)

      // 如果双击的是文本节点，并且当前工具是选择工具
      if (e.target.getClassName() === 'Text' && this.currentTool === TOOLS.SELECT) {
        console.log('Double clicked on text node')

        // 获取文本节点
        const textNode = e.target

        // 先选中文本
        this.deselectShape()
        this.selectedShape = textNode
        this.selectedShapeType = 'text'
        this.selectedShapeIndex = this.texts.findIndex((t) => {
          return t === textNode
        })
        this.transformer.nodes([textNode])
        this.mainLayer.draw()

        // 然后开始编辑
        setTimeout(() => {
          this.startTextEdit(textNode)
        }, 10)

        // 阻止事件冒泡
        e.cancelBubble = true
      }
    },

    // 全局拖动结束事件
    handleGlobalDragEnd(e) {
      if (this.selectedShape && e.target === this.selectedShape) {
        // 使用 setTimeout 确保在拖动完全结束后更新位置
        setTimeout(() => {
          this.updatePropertyPanelPosition()
        }, 0)
      }
    },

    // 添加 handleDragMove 函数，实时更新属性面板位置
    handleDragMove(e) {
      if (this.selectedShape && e.target === this.selectedShape) {
        // 实时更新属性面板位置
        this.updatePropertyPanelPosition()
      }
    },

    // 添加文本事件
    addTextEvents() {
      if (!this.mainLayer) return

      const textNodes = this.mainLayer.find('Text')
      textNodes.forEach((textNode) => {
        // 移除现有的事件，避免重复
        textNode.off('mousedown touchstart')
        textNode.off('dblclick')

        // 添加点击事件
        textNode.on('mousedown touchstart', (e) => {
          if (this.currentTool === TOOLS.SELECT) {
            e.cancelBubble = true
            this.selectShape(textNode)
            this.showPropertyPanel = true
            this.$nextTick(() => {
              this.updatePropertyPanelPosition()
            })
          }
        })

        // 添加双击事件
        textNode.on('dblclick', (e) => {
          if (this.currentTool === TOOLS.SELECT) {
            e.cancelBubble = true
            this.selectShape(textNode)
            this.startTextEdit(textNode)
          }
        })
      })
    },

    // 更新形状属性
    updateStrokeColor(color) {
      if (!this.selectedShape) return

      try {
        const shape = this.selectedShape

        // 更新选中状态变量
        this.selectedShapeStrokeColor = color

        // 暂时移除变换器
        const hasTransformer = this.transformer && this.transformer.nodes().includes(shape)
        if (hasTransformer) {
          this.transformer.detach()
        }

        // 根据形状类型更新颜色
        if (shape.getClassName() === 'Text') {
          shape.fill(color)
          shape.stroke('transparent')
        } else if (shape.getClassName() === 'Arrow') {
          shape.stroke(color)
          shape.fill('transparent')
          shape.pointerFill('transparent')
        } else {
          shape.stroke(color)
        }

        // 重新添加变换器
        if (hasTransformer) {
          this.transformer.nodes([shape])
          this.transformer.forceUpdate()
        }

        // 重绘图层
        this.mainLayer.batchDraw()

        // 立即保存到历史记录
        this.saveToHistory()
      } catch (error) {
        console.error('Error updating stroke color:', error)
      }
    },

    updateStrokeWidth(width) {
      try {
        if (!this.selectedShape || !this.mainLayer) {
          console.warn('No shape selected')
          return
        }

        // Update the selected width value
        this.selectedShapeStrokeWidth = width

        // Get the shape
        const shape = this.selectedShape

        // Store current transformer state
        const hasTransformer = this.transformer && this.transformer.nodes().includes(shape)

        // Temporarily detach the transformer if it exists
        if (hasTransformer) {
          this.transformer.detach()
        }

        // Handle text shapes differently
        if (shape.getClassName() === 'Text') {
          // Save current text properties
          const currentWidth = shape.width()
          const currentScale = shape.scaleX()

          // For text, adjust font size and style instead of stroke width
          if (width <= 2) {
            shape.fontStyle('normal')
          } else {
            shape.fontStyle('bold')
          }

          // Adjust font size based on width
          const fontSize =
            width === 1 ? 14 : width === 2 ? 16 : width === 4 ? 18 : width === 6 ? 20 : 22
          shape.fontSize(fontSize)

          // Restore width and scale if they exist
          if (currentWidth && currentScale) {
            shape.width(currentWidth)
            shape.scaleX(currentScale)
          }
        } else if (shape.name() === 'cloud') {
          // Special handling for cloud shapes
          try {
            // Store current cloud properties
            const currentAttrs = shape.getAttrs()
            const currentPath = shape.data()
            const currentX = shape.x()
            const currentY = shape.y()
            const currentScaleX = shape.scaleX()
            const currentScaleY = shape.scaleY()
            const currentRotation = shape.rotation()

            // Create a new path with the same properties but updated stroke width
            const newPath = new Konva.Path({
              ...currentAttrs,
              strokeWidth: width,
              data: currentPath,
              x: currentX,
              y: currentY,
              scaleX: currentScaleX,
              scaleY: currentScaleY,
              rotation: currentRotation,
            })

            // Replace the old shape with the new one
            shape.destroy()
            this.mainLayer.add(newPath)
            this.selectedShape = newPath

            // Update the clouds array
            const index = this.clouds.indexOf(shape)
            if (index !== -1) {
              this.clouds[index] = newPath
            }

            // 绑定事件
            this.bindCloudShapeEvents(newPath)
          } catch (error) {
            console.error('Error updating cloud shape:', error)
          }
        } else {
          // For other shapes, update stroke width directly
          shape.strokeWidth(width)
        }

        // Reattach the transformer if it was present
        if (hasTransformer) {
          this.transformer.nodes([this.selectedShape])
          this.transformer.forceUpdate()
        }

        // Redraw the layer
        this.mainLayer.batchDraw()

        // 立即保存到历史记录
        this.saveToHistory()
      } catch (error) {
        console.error('Error updating stroke width:', error)
      }
    },

    // 删除选中的形状
    deleteSelectedShape() {
      try {
        console.log('Deleting selected shape:', this.selectedShapeType, this.selectedShapeIndex)

        // 确保有选中的形状
        if (!this.selectedShape) {
          console.warn('No shape selected to delete')
          return
        }

        // 根据形状类型删除对应的形状
        if (this.selectedShapeType === 'rect' && this.selectedShapeIndex >= 0) {
          // 从数组中移除
          const rect = this.rectangles.splice(this.selectedShapeIndex, 1)[0]
          // 从图层中移除
          rect.destroy()
        } else if (this.selectedShapeType === 'ellipse' && this.selectedShapeIndex >= 0) {
          const ellipse = this.ellipses.splice(this.selectedShapeIndex, 1)[0]
          ellipse.destroy()
        } else if (this.selectedShapeType === 'line' && this.selectedShapeIndex >= 0) {
          const line = this.lines.splice(this.selectedShapeIndex, 1)[0]
          line.destroy()
        } else if (this.selectedShapeType === 'arrow' && this.selectedShapeIndex >= 0) {
          const arrow = this.arrows.splice(this.selectedShapeIndex, 1)[0]
          arrow.destroy()
        } else if (this.selectedShapeType === 'text' && this.selectedShapeIndex >= 0) {
          const text = this.texts.splice(this.selectedShapeIndex, 1)[0]
          text.destroy()
        } else if (this.selectedShapeType === 'path' && this.selectedShapeIndex >= 0) {
          const path = this.paths.splice(this.selectedShapeIndex, 1)[0]
          path.destroy()
        } else if (this.selectedShapeType === 'cloud' && this.selectedShapeIndex >= 0) {
          const cloud = this.clouds.splice(this.selectedShapeIndex, 1)[0]
          cloud.destroy()
        } else {
          console.warn(
            'Unknown shape type or invalid index:',
            this.selectedShapeType,
            this.selectedShapeIndex
          )

          // 尝试直接删除选中的形状
          if (this.selectedShape) {
            this.selectedShape.destroy()
          }
        }

        // 更新图层
        this.mainLayer.batchDraw()

        // 取消选中
        this.deselectShape()

        // 保存历史记录
        this.saveToHistory()

        console.log('Shape deleted successfully')
      } catch (error) {
        console.error('Error deleting shape:', error)
      }
    },

    // 从历史记录恢复状态
    restoreFromHistory(index) {
      try {
        if (!this.mainLayer || index < 0 || index >= this.history.length) return

        // 清除当前所有形状
        this.mainLayer.destroyChildren()

        // 从历史记录恢复形状
        const shapes = this.history[index]
        shapes.forEach((shapeData) => {
          let shape
          const attrs = { ...shapeData.attrs }

          // 根据形状类型创建对应的形状
          switch (shapeData.className) {
            case 'Circle':
              shape = new Konva.Circle(attrs)
              this.circles.push(shape)
              break
            case 'Rect':
              shape = new Konva.Rect(attrs)
              this.rectangles.push(shape)
              break
            case 'Line':
              shape = new Konva.Line(attrs)
              this.lines.push(shape)
              break
            case 'Arrow':
              shape = new Konva.Arrow(attrs)
              this.arrows.push(shape)
              break
            case 'Text':
              shape = new Konva.Text(attrs)
              this.texts.push(shape)
              break
            case 'Path':
              shape = new Konva.Path(attrs)
              if (attrs.name === 'cloud') {
                this.clouds.push(shape)
              } else {
                this.paths.push(shape)
              }
              break
          }

          if (shape) {
            // 添加事件监听器
            shape.on('mousedown touchstart', (e) => {
              this.handleShapeMouseDown(e, shape)
            })
            shape.on('dragmove', this.handleDragMove)
            shape.on('dragend', this.handleDragEnd)
            shape.on('transformend', this.handleTransformEnd)

            // 添加到图层
            this.mainLayer.add(shape)
          }
        })

        // 更新当前索引
        this.currentHistoryIndex = index

        // 重新创建变换器
        this.transformer = new Konva.Transformer({
          rotateEnabled: true,
          enabledAnchors: [
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
            'middle-left',
            'middle-right',
          ],
          boundBoxFunc(oldBox, newBox) {
            // 设置最小尺寸
            const minWidth = 20
            const minHeight = 20

            // 确保不会小于最小尺寸
            if (newBox.width < minWidth) {
              newBox.width = minWidth
            }
            if (newBox.height < minHeight) {
              newBox.height = minHeight
            }

            return newBox
          },
        })
        this.mainLayer.add(this.transformer)

        // 重绘图层
        this.mainLayer.batchDraw()
      } catch (error) {
        console.error('Error restoring history:', error)
      }
    },

    // 撤销
    handleUndo() {
      console.log('Undo clicked', {
        currentIndex: this.currentHistoryIndex,
        historyLength: this.history.length,
      })
      if (this.currentHistoryIndex > 0) {
        // 先取消当前选择和属性面板
        this.deselectShape()
        this.showPropertyPanel = false
        this.removePropertyPanel()

        // 重置选中状态
        this.selectedShape = null
        this.selectedShapeType = null
        this.selectedShapeIndex = -1

        // 重置属性值到默认状态
        this.selectedShapeStrokeColor = DEFAULT_COLORS.STROKE
        this.selectedShapeStrokeWidth = 2

        // 执行撤销操作
        this.currentHistoryIndex--
        this.restoreFromHistory(this.currentHistoryIndex)

        // 确保变换器被清除
        if (this.transformer) {
          this.transformer.nodes([])
          this.mainLayer.draw()
        }
      }
    },

    // 重置
    handleReset() {
      try {
        // 首先取消选择当前形状
        this.deselectShape()

        // 清除所有图层
        if (this.mainLayer) {
          // 完全清除所有子节点，包括变换器
          this.mainLayer.destroyChildren()

          // 重新创建变换器
          this.transformer = new Konva.Transformer({
            rotateEnabled: true,
            enabledAnchors: [
              'top-left',
              'top-right',
              'bottom-left',
              'bottom-right',
              'middle-left',
              'middle-right',
            ],
            boundBoxFunc(oldBox, newBox) {
              // 设置最小尺寸
              const minWidth = 20
              const minHeight = 20

              // 确保不会小于最小尺寸
              if (newBox.width < minWidth) {
                newBox.width = minWidth
              }
              if (newBox.height < minHeight) {
                newBox.height = minHeight
              }

              return newBox
            },
          })
          this.mainLayer.add(this.transformer)

          // 重绘图层
          this.mainLayer.batchDraw()
        }

        // 清空所有形状数组
        this.rectangles = []
        this.ellipses = []
        this.lines = []
        this.arrows = []
        this.texts = []
        this.paths = []
        this.clouds = []

        // 重置所有状态变量
        this.selectedShape = null
        this.selectedShapeType = null
        this.selectedShapeIndex = -1
        this.selectedShapeStrokeColor = DEFAULT_COLORS.STROKE
        this.selectedShapeStrokeWidth = 2
        this.showPropertyPanel = false
        this.isDrawing = false
        this.currentPath = null

        // 重置历史记录
        this.history = []
        this.currentHistoryIndex = -1

        // 移除属性面板
        this.removePropertyPanel()

        // 保存初始空白状态到历史记录
        this.$nextTick(() => {
          this.saveToHistory()
        })

        console.log('Reset completed successfully')
      } catch (error) {
        console.error('Error during reset:', error)
      }
    },
    handleSaveAndSend(userId) {
      // 保存并转发
      console.log(userId, 'userId')
      this.handleSave(false, userId)
    },
    // 保存批注
    handleSave(isApprove, userId) {
      // 获取API配置
      const currentStandardId =
        this.getUrlParam(decodeURIComponent(window.top.location.href), 'standardId') ||
        localStorage.getItem('standardId')
      console.log(currentStandardId, 'currentStandardId-11')
      try {
        if (!this.stage) {
          console.error('Stage not initialized')
          return
        }

        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: isApprove ? '正在保存并提交审批...' : userId ? '正在保存并转发...' : '正在保存...',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.file-preview-container', // 指定容器
          fullscreen: false, // 不使用全屏模式
          body: true, // 将遮罩层添加到 body 上
        })

        // 暂时隐藏变换器，这样它不会出现在导出的图像中
        if (this.transformer) {
          this.transformer.visible(false)
          this.mainLayer.draw()
        }

        // 获取当前舞台尺寸
        const stageWidth = this.stage.width()
        const stageHeight = this.stage.height()

        // 计算缩放比例 (目标最大尺寸为 1920px)
        const maxDimension = 1920
        const scale = Math.min(1, maxDimension / Math.max(stageWidth, stageHeight))

        // 使用 Konva 的 toDataURL 方法获取整个舞台的 base64 图像
        const dataURL = this.stage.toDataURL({
          pixelRatio: scale, // 使用计算出的缩放比例
          mimeType: 'image/jpeg', // 使用 JPEG 格式以获得更好的压缩率
          quality: 0.8, // 设置 JPEG 质量为 0.8 (0-1 之间)
          width: stageWidth * scale,
          height: stageHeight * scale,
        })
        console.log(dataURL, 'dataURL')
        // 恢复变换器可见性
        if (this.transformer) {
          this.transformer.visible(true)
          this.mainLayer.draw()
        }
        const self = this
        const currentViewFileTile = localStorage.getItem('currentViewFileTitle')
        // 执行保存操作
        window.top.V8.ApiEngine.Run('imgtoword', {
          FileBase64: dataURL.split('base64,')[1],
          FileName: currentViewFileTile,
          Content: self.getAnnotationTexts(),
          TplKey: 'AnnotationResults',
        })
          .then((imgToWordRes) => {
            if (imgToWordRes?.Code !== 1) {
              throw new Error(imgToWordRes?.Message || '转换失败')
            }

            window.top.V8.ApiEngine.Run('fileview_submit', {
              Annotation: dataURL.split('base64,')[1],
              FileName: `${currentViewFileTile}-批注-${window.top.V8.dayjs().format(
                'YYYY-MM-DD HH:mm:ss'
              )}`,
              DataStandard: currentStandardId,
              Content: self.getAnnotationTexts(),
              AnnotationBase64: imgToWordRes.Data.FileByteBase64,
              ReviewRecord: `${currentViewFileTile}-批注-${dayjs().format('YYYY-MM-DD HH:mm:ss')}`,
              IsApprove: isApprove,
              userId,
            })
              .then((response) => {
                if (response?.Code !== 1) {
                  throw new Error(response?.Message || '保存失败')
                }
                const successMessage = isApprove
                  ? '保存并提交审批成功'
                  : userId
                  ? '保存并转发成功'
                  : '保存成功'
                self.$message.success(successMessage)
                loading.close()
                if (userId) {
                  self.showForwardDialog = false
                }
                console.log('Image saved as base64')
              })
              .catch((error) => {
                console.error('Error saving annotation:', error)
                loading.close()
                self.$message.error(error.message || '保存失败')
              })
          })
          .catch((error) => {
            console.error('Error converting to Word:', error)
            loading.close()
            self.$message.error(error.message || '转换失败')
          })
      } catch (error) {
        console.error('Error saving image:', error)
        self.$message.error(error.message || '保存失败')
      }
    },

    // 关闭组件
    closeComponent() {
      this.$emit('close')
    },

    // 获取所有批注文本内容
    getAnnotationTexts() {
      if (!this.stage || !this.mainLayer) {
        return []
      }

      const textNodes = this.mainLayer.find('Text')
      const textContents = textNodes.map((textNode) => {
        const position = textNode.absolutePosition()
        return {
          text: textNode.text(),
          x: Math.round(position.x),
          y: Math.round(position.y),
          fontSize: textNode.fontSize(),
          color: textNode.fill(),
          id: textNode._id,
        }
      })
      let textStr = ''
      textContents.forEach((item, index) => {
        textStr += `${index + 1}. ${item.text}\n`
      })

      return textStr
    },

    // 下载Word文档
    handleDownloadWord() {
      try {
        if (!this.stage) {
          this.$message.error('画布未初始化')
          return
        }

        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '正在生成文档...',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.file-preview-container', // 指定容器
          fullscreen: false, // 不使用全屏模式
          body: true, // 将遮罩层添加到 body 上
        })

        try {
          // 暂时隐藏变换器
          if (this.transformer) {
            this.transformer.visible(false)
            this.mainLayer.draw()
          }
          const imgWidth = this.stage.attrs.width
          const imgHeight = this.stage.attrs.height
          const wordImgWidth = 555
          const wordImgHeight = (imgHeight / imgWidth) * wordImgWidth
          // 获取高质量图像
          const dataURL = this.stage.toDataURL({
            pixelRatio: 2,
            mimeType: 'image/png',
          })

          // 恢复变换器可见性
          if (this.transformer) {
            this.transformer.visible(true)
            this.mainLayer.draw()
          }
          const currentViewFileTile = localStorage.getItem('currentViewFileTitle')
          // 调用API转换为Word
          window.top.V8.ApiEngine.Run('imgtoword', {
            FileBase64: dataURL.split('base64,')[1],
            FileName: currentViewFileTile,
            Content: this.getAnnotationTexts(),
            TplKey: 'AnnotationResults',
          })
            .then((response) => {
              if (response?.Code !== 1) {
                throw new Error(response?.Message || '转换失败')
              }

              // 创建下载链接
              const byteString = atob(response.Data.FileByteBase64)
              const ab = new ArrayBuffer(byteString.length)
              const ia = new Uint8Array(ab)
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
              }
              const blob = new Blob([ab], {
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              })
              const url = URL.createObjectURL(blob)

              // 创建下载链接并触发点击
              const a = document.createElement('a')
              a.href = url
              a.download = `${currentViewFileTile}-批注.docx`
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)

              loading.close()
              this.$message.success('文档导出成功')
            })
            .catch((error) => {
              console.error('Error generating Word document:', error)
              loading.close()
              this.$message.error(error.message || '导出失败')
            })
        } catch (error) {
          console.error('Error generating image:', error)
          loading.close()
          this.$message.error(error.message || '导出失败')
        }
      } catch (error) {
        console.error('Error downloading document:', error)
        this.$message.error(error.message || '导出失败')
      }
    },

    // 取消选择形状
    deselectShape() {
      // 清除选中状态
      this.selectedShape = null
      this.selectedShapeType = null
      this.selectedShapeIndex = -1

      // 清除变换器
      if (this.transformer) {
        this.transformer.nodes([])
        this.mainLayer.draw()
      }

      // 隐藏属性面板
      this.showPropertyPanel = false
    },

    handleForward() {
      // 先保存当前状态
      this.showForwardDialog = true
    },

    // 转发成功回调
    handleForwardSuccess() {
      this.$message.success('转发成功')
    },

    // 绑定云形事件
    bindCloudShapeEvents(shape) {
      shape.on('mousedown touchstart', (e) => {
        const pointer = this.stage.getPointerPosition()
        const context = shape.getLayer().getContext()._context
        context.save()
        context.lineWidth = shape.strokeWidth()
        context.beginPath()
        const path2d = new window.Path2D(shape.data())
        context.stroke(path2d)
        const isOnStroke = context.isPointInStroke(path2d, pointer.x, pointer.y)
        context.restore()

        if (isOnStroke) {
          shape.draggable(true)
          this.handleShapeMouseDown(e, -1, 'cloud')
        } else {
          shape.draggable(false)
          if (this.selectedShape) {
            this.deselectShape()
            e.cancelBubble = true
          }
        }
      })
      // 鼠标松开后恢复可拖动
      shape.on('mouseup touchend', () => {
        shape.draggable(true)
      })
      // 绑定拖动、变换等通用事件
      shape.on('dragmove', this.handleDragMove)
      shape.on('dragend', this.handleDragEnd)
      shape.on('transformend', this.handleTransformEnd)
    },
  },
}
</script>

<style lang="scss" scoped>

.image-annotator-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh; /* Use viewport height to ensure full screen height */
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: none;
  box-sizing: border-box; /* Ensure padding doesn't add to dimensions */

  .toolbar {
    padding: 0;
    margin: 0;
    flex-shrink: 0;
    background: #fff;
    border-bottom: 1px solid #ddd;
    z-index: 100;

    .toolbar-container {
      margin: 0;
      padding: 2px;
    }

    .tool-button {
      &.active {
        background: #e6f7ff;
        border-color: #1890ff;
      }

      &:hover {
        background: #f0f0f0;
      }
    }

    .action-button {
      &:hover {
        background: #f0f0f0;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;

        &:hover {
          background: white;
        }
      }
    }
  }

  .canvas-container {
    flex: 1;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: calc(100% - 1px); /* Account for the toolbar border */
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    .stage-container {
      width: 100% !important;
      height: 100% !important;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      overflow: hidden;
      box-sizing: border-box;

      /* Ensure all Konva canvas elements fill the container */
      canvas {
        width: 100% !important;
        height: 100% !important;
        display: block; /* Remove any inline spacing */
      }
    }

    .floating-property-panel {
      background: white;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      position: relative;
      border: 1px solid #e8e8e8;
      z-index: 1000;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 6px;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
        pointer-events: none;
      }

      // Add arrow pointing to the shape
      &::after {
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        background: white;
        transform: rotate(45deg);
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);
        z-index: -1;
        border: 1px solid #e8e8e8;
        border-top: none;
        border-left: none;
      }

      // Position arrow based on panel position relative to shape
      &.above-shape::after {
        bottom: -8px;
        left: 50%;
        margin-left: -8px;
        box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.15);
      }

      &.below-shape::after {
        top: -8px;
        left: 50%;
        margin-left: -8px;
        box-shadow: -2px -2px 3px rgba(0, 0, 0, 0.15);
        border: 1px solid #e8e8e8;
        border-bottom: none;
        border-right: none;
      }

      .property-panel-content {
        padding: 10px;
        min-width: 180px;

        .property-item {
          margin-bottom: 10px;

          .property-label {
            font-size: 13px;
            color: #333;
            margin-bottom: 6px;
            display: block;
            font-weight: 500;
          }

          .color-options {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;

            .color-option {
              width: 22px;
              height: 22px;
              border-radius: 4px;
              cursor: pointer;
              border: 1px solid #ddd;
              transition: transform 0.1s ease;

              &:hover {
                transform: scale(1.1);
              }

              &.active {
                border: 2px solid #1890ff;
              }
            }
          }

          .width-options {
            display: flex;
            align-items: center;
            gap: 8px;

            .width-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 32px;
              height: 22px;
              cursor: pointer;
              border: 1px solid #ddd;
              border-radius: 4px;
              transition: background-color 0.1s ease;

              &:hover {
                background-color: #f5f5f5;
              }

              &.active {
                border: 2px solid #1890ff;
                background-color: #e6f7ff;
              }

              .width-preview {
                width: 80%;
                border-radius: 2px;
              }
            }
          }

          .delete-button {
            background: #ff4d4f;
            color: white;
            border: none;
            padding: 6px 10px;
            border-radius: 4px;
            cursor: pointer;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            font-size: 14px;
            transition: background 0.2s ease;

            &:hover {
              background: #ff7875;
            }
          }
        }
      }
    }
  }
}

.text-editor {
  position: fixed;
  z-index: 10000;
  font-family: Arial;
  border: 1px solid #1890ff;
  padding: 4px;
  resize: none;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

</style>
